// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"7b379ac5","428":"d7d7bb9a","637":"dc8fdc5f","741":"ab2ec89d","751":"a8047cd2","777":"d17d752f"}[chunkId] + ".chunk.js";
};